import { MaterialsFactory } from '../factories/MaterialsFactory';
import { TexturesStorage } from '../factories/TexturesStorage';

const THREE = require('three');

class PlaneDecorRectangle extends THREE.Group {
    constructor(objectConfig) {
        super();

        this._opacity = 1;

        this._constructView(objectConfig);
    }

    async _constructView(config) {
        const { textures } = config;
        const { width, height, scale } = config.geometry;

        const texture = await TexturesStorage.getTexture({ options: textures });
        const geom = new THREE.PlaneBufferGeometry(width * scale, height * scale);
        const material = MaterialsFactory.create({
            map: texture,
            transparent: true,
            color: 0xffffff
        });

        material.fog = true;
        material.opacity = this._opacity;

        const mesh = new THREE.Mesh(geom, material);

        // mesh.position.y = h;

        this.add(mesh);

        this._material = material;
    }

    set opacity(value) {
        this._opacity = value;
        if (!this._material) return;
        this._material.opacity = value;
    }

    get opacity() {
        return this._opacity;
    }
}

export default PlaneDecorRectangle;
